import {
    AfterContentChecked,
    AfterViewInit,
    Component,
    EventEmitter,
    Inject,
    OnInit,
    Output
} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {
    ApiMode,
    CameraSettingTab,
    Organization,
    Role
} from '@pages/camera-settings/models';
import {OrganizationService} from '@services/organization.service';
import {RoleService} from '@services/role.service';
import {faCamera, faTimes} from '@fortawesome/free-solid-svg-icons';

export interface DialogData {
    properties: CameraSettingTab[];
    userId: number;
    userName: string;
    roleId: number;
    roleName: string;
    companyId: number;
    companyName: string;
    mode: ApiMode;
    organizations: Organization[];
    isSiteAdmin: boolean;
    roles: Role[];
}

@Component({
    selector: 'app-changes-dialog',
    templateUrl: './changes-dialog.component.html',
    styleUrls: ['./changes-dialog.component.scss']
})
export class ChangesDialogComponent implements AfterContentChecked {
    @Output() manualRefresh: EventEmitter<void> = new EventEmitter<void>();
    UndoClick = new EventEmitter();

    ModifiedSettings: CameraSettingTab[] = [];
    organizations: Organization[] = [];
    selectedOrganizationId: number = 1;
    selectedRoleId: number = 1;
    roles: Role[] = [];
    updateType: string = '';
    faTimes = faTimes;
    userId: number = 0;
    userName: string = '';
    roleId: number = 0;
    roleName: string = '';
    companyId: number = 0;
    companyName: string = '';
    mode: ApiMode = ApiMode.User;
    modifiedCount: number = 0;
    faCamera = faCamera;
    isSiteAdmin: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        @Inject(OrganizationService) public organizationsService,
        @Inject(RoleService) public roleService,
        public dialogRef: MatDialogRef<ChangesDialogComponent>
    ) {
        this.isSiteAdmin = data.isSiteAdmin;
        this.ModifiedSettings = data.properties;
        this.organizations = data.organizations;
        this.roles = data.roles;

        this.modifiedCount = this.ModifiedSettings.reduce(
            (total, x) =>
                total +
                x.groups?.reduce(
                    (groupTotal, y) => groupTotal + y.initialValues.length,
                    0
                ),
            0
        );

        this.userId = data.userId;
        this.selectedRoleId = data.roleId;
        this.selectedOrganizationId = data.companyId;
        this.userName = data.userName;

        if (data.mode == ApiMode.Company) {
            this.updateType = 'Organization';
        } else if (data.mode == ApiMode.Role) {
            this.updateType = 'Role';
        } else {
            this.updateType = 'User';
        }
    }

    ngAfterContentChecked(): void {
        this.manualRefresh.emit();
    }

    onOrganizationChange($event: any) {
        this.selectedOrganizationId = $event.value;
    }

    onRoleChange($event: any) {
        this.selectedRoleId = $event.value;
    }

    onTypeChange($event: any) {
        this.updateType = $event.value;
    }

    closeDialog() {
        this.dialogRef.close({
            Status: false,
            OrganizationId: this.selectedOrganizationId,
            RoleId: this.selectedRoleId,
            UpdateType: this.updateType
        });
    }

    onSuccessClick() {
        this.dialogRef.close({
            Status: true,
            OrganizationId: this.selectedOrganizationId,
            RoleId: this.selectedRoleId,
            UpdateType: this.updateType
        });
    }

    resetProp(propertyName: string) {
        this.modifiedCount--;
        this.UndoClick.emit(propertyName);

        this.ModifiedSettings.forEach((x) =>
            x.groups.forEach(
                (y) =>
                    (y.initialValues = y.initialValues.filter((z) => {
                        return z.propertyName != propertyName;
                    }))
            )
        );

        this.ModifiedSettings = this.ModifiedSettings.filter((setting) => {
            return setting.groups.some(
                (group) => group.initialValues.length > 0
            );
        });
    }
}
